module.exports = __webpack_public_path__ + "static/media/fig_3b.acaea784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_3b.jpg
// module id = 674
// module chunks = 0